<form [formGroup]="productionCostsForm" class="export-form-container">
  @if (this.isExport) {
    <mat-form-field>
      <mat-label i18n>Design & Project Management USA</mat-label>
      <input formControlName="design" i18n-placeholder matInput min="0" placeholder="Design & Project Management USA"
        type="number">
      </mat-form-field>
    }
    @if (this.isExport) {
      <mat-form-field>
        <mat-label i18n>Shipping USA</mat-label>
        <input formControlName="shipping" i18n-placeholder matInput min="0" placeholder="Shipping USA" type="number">
      </mat-form-field>
    }
    @if (this.isExport) {
      <mat-form-field>
        <mat-label i18n>Exchange rate</mat-label>
        <input class="no-spinner" formControlName="exchangeRate" i18n-placeholder matInput min="0"
          placeholder="Exchange rate"
          type="number">
          @if (canRefreshRate) {
            <button (click)="refreshExchangeRate()" mat-icon-button matSuffix type="button">
              <mat-icon>refresh</mat-icon>
            </button>
          }
          <mat-hint>{{ exchangeRateHint }}</mat-hint>
        </mat-form-field>
      }
      <button (click)="submit()" [disabled]="!productionCostsForm.valid || operationInProgress" mat-button type="submit">
        Save
      </button>
      @if (this.isExport) {
        <button (click)="changeTab('Overseas')" [disabled]="operationInProgress" mat-button
          type="button">
          Add materials "Overseas"
        </button>
      }
    </form>
